import React from 'react'
import { styled } from "../../../stitches.config";
import { h1, h2, h3, h4, p } from '../../commonStyles/Fonts';
import { ReactComponent as FaqShadow } from '../../../assets/img/natemat/career/faq.svg?react';
import FaqCard from './FaqCard';

interface FaqProps {
    items?: {
        title: string,
        text: string,
    }[],
    header: string,
}

const Faq = ({ items, header }: FaqProps) => {

    const defaultFaq = [
        {
            title: 'Jak wygląda proces rekrutacji?',
            text: 'Możesz odpowiedzieć na aktualna ofertę rekrutacyjną, ale równie dobrze możesz napisać do nas i bez niej. Następnie zapraszamy wybranych kandydatów na rozmowę rekrutacyjną: na żywo lub w formie wideokonferencji. Na początku zawsze spotykasz się z menadżerem działu, do którego aplikujesz. Jeśli stanowisko tego wymaga, w spotkaniu może uczestniczyć także menadżer działu, z którym na co dzień często będziesz mieć do czynienia. Chcemy na nim poznać Ciebie bliżej, usłyszeć o Twoim dotychczasowym doświadczeniu zawodowym i oczekiwaniach względem pracy w naTemat. Czasami zdarza się, że jest też drugi etap rekrutacji.Wtedy ponownie zapraszamy na rozmowę w szerszym gronie.Jeśli aplikujesz na stanowisko dziennikarskie, bardzo prawdopodobne, że zostaniesz poproszony o zaproponowanie tematów, które chciałbyś zrealizować jako dziennikarz, albo o napisanie tekstu próbnego. Żaden z nich nie zostanie nigdzie wykorzystany ani opublikowany.'
        },
        {
            title: 'O czym mogę pisać?',
            text: 'O wszystkim co ciekawe i aktualne. Newsy, reportaże, analizy, przeglądy, recenzje, wywiady, opinie, wideo i podcasty na naprawdę wiele tematów. Nie zamykamy się na żadną formę i tematykę. Piszemy rzetelnie zarówno o rzeczach najważniejszych, jak i tych bliskich naszemu codziennemu życiu. Pamiętaj tylko, że ważne jest, by zainteresować nią naszych czytelników.',
        },
        {
            title: 'O czym nie mogę pisać?',
            text: 'Nie ma tematów, o których u nas „nie można pisać". Musi być jedynie ciekawie i zgodnie z misją oraz wartościami Grupy naTemat. Tematy artykułów zgłaszają dziennikarze, a ostateczną decyzją o ich realizacji podejmuje wydawca dnia lub redaktor prowadzący.',
        },
    ]

    const faqContent = items ? items : defaultFaq;

    return (
        <FaqContainer>
            <h2 className={h2()}>{header}</h2>
            <FaqWrapper>
                {
                    faqContent.map((item) => <FaqCard text={item.text} title={item.title} />)
                }
            </FaqWrapper>
            <ShadowText><FaqShadow /></ShadowText>
        </FaqContainer>
    )
}

export default Faq;

const FaqContainer = styled('div', {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '$grayscale10',
    color: '$grayscale100',
    width: '100%',
    zIndex: 10000,
    'h2': {
        //    width: '240px',
        padding: '0 12px',
        textAlign: 'center',
        marginTop: '154px',
        marginBottom: '24px',
        fontSize: '24px',
        fontHeight: '30px',
    },
    '@bp4': {
        'h2': {
            marginBottom: '56px',
            width: '100%',
            marginTop: '128px',
            fontSize: '38px',
            fontHeight: '42px',
        }
    }
})

const FaqWrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '90%',
    marginBottom: '56px',
    'details': {
        backgroundColor: '$grayscale0',
        zIndex: '100',
        padding: '16px 16px 16px 20px',
        '&[open]': {
            'summary': {
                'svg': {
                    transform: 'rotate(180deg)',
                }
            }
        }
    },
    'details div': {
        marginTop: '25px',
    },
    'details summary': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        'svg': {
            'path': {
                fill: '$grayscale0',
            },
            flexShrink: 0,
            borderRadius: '50%',
            backgroundColor: '$primary',
            width: '24px',
            height: '24px',
            padding: '8px',
            transform: 'rotate(0deg)',
        },
    },
    'details summary > *': {
        display: "inline",
    },
    '@bp4': {
        width: '840px',
        marginBottom: '168px',
        'details': {
            padding: '24px 24px 24px 32px',
            backgroundColor: '$grayscale0',
            'summary': {
                cursor: 'pointer',
                'svg': {
                    'path': {
                        fill: '$grayscale0',
                    },
                    flexShrink: 0,
                    borderRadius: '50%',
                    backgroundColor: '$primary',
                    width: '32px',
                    height: '32px',
                    padding: '10px',
                    transform: 'rotate(0deg)',
                },
                '& > *': {
                    display: "inline",
                },
            },
        },


    }
})


const ShadowText = styled('div', {
    position: 'absolute',
    top: '25px',
    right: '0px',
    userSelect: 'none',
    'svg': {
        width: '76px',
        height: '54px',
    },
    '@bp4': {
        top: '70%',
        left: '10%',
        zIndex: 0,
        'svg': {
            width: 'max-content',
            height: '168px',
        }
    }
})

const OrangeSpan = styled('span', {
    color: '$natematPrimary',
})
